/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { type Dispatch, type SetStateAction, useEffect } from 'react'
import { Card, CardContent, CircularProgress, Grid, Box, Tab } from '@mui/material'
import { type AssetByIdState } from '../redux/slices/assetByIdSlice'
import AssetSummary from './AssetSummary'
import AlarmHistory from './alarmHistory'
import ActiveIssuesTable from './ActiveIssues'
import { type AlarmByIdState } from '../redux/slices/alarmsByIdSlice'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { useNavigate } from 'react-router-dom'
import { type RootState } from '../../../store'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useSelector } from 'react-redux'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { type AssetPropertiesByIdState } from '../redux/slices/assetPropertiesByIdSlice'
import LanguageStrings from '../../../i18n/locales'
import { Button } from '../../../components/Button'

const OverviewStrings = LanguageStrings().DeviceDetailsStrings.Overview

const Overview = (props: { handleFetchAssetData: () => void, fetchAlarmsById: () => void, fetchAlarmHistory: (assetId: string, page: number, size: number) => void, assetData: AssetByIdState, OverviewStrings: any, assetPropertiesData: AssetPropertiesByIdState, alarmsById: AlarmByIdState, page: number, setPage: Dispatch<SetStateAction<number>>, rowsPerPage: number }): JSX.Element => {
  const navigate = useNavigate()
  const [value, setValue] = React.useState('1')
  const totalCount = useSelector((state: any) => state.alarmHistoryState?.alarmHistoryData?.totalCount)
  const assetId = sessionStorage.getItem('paramAssetId')

  useEffect(() => {
    if (assetId !== null) {
      props.fetchAlarmHistory(assetId, 0, 10)
    }
  }, [assetId])

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const handleRetry = (): void => {
    props.fetchAlarmsById()
  }

  function AlarmTable (): any {
    if (props.alarmsById.isLoading) {
      return (
        <div className='deviceDetailsProgress'><CircularProgress data-testid='deviceDetailsProgress' size={'5rem'} /></div>)
    } else if (props.alarmsById.httpStatus === 401) {
      return (
        <div className='authError'><AuthError errorMessage="Unauthorized" /></div>
      )
    } else if (props.alarmsById.httpStatus === 403) {
      return (
        <div className='authError'><AuthError errorMessage="accessForbidden" /></div>
      )
    } else if (props.alarmsById.alarmData !== null && props.alarmsById.alarmData !== undefined && props.alarmsById.httpStatus === 200) {
      return (
        <ActiveIssuesTable deviceType={props.assetData?.assetData?.device_type ?? ''} alarmsById={props.alarmsById} OverviewStrings={props.OverviewStrings} page={props.page} setPage={props.setPage} rowsPerPage={props.rowsPerPage}/>)
    } else if ((props.alarmsById.alarmData !== null && props.alarmsById.alarmData !== undefined && props.alarmsById.alarmData.alarmDetails.length === 0)) {
      return (
        <div className='authError'><AuthError errorMessage="NoDataPresent" /></div>
      )
    } else if (((props.alarmsById.errorMessage?.includes('not found')) === true)) {
      return (
        <div className='authError'><AuthError errorMessage="NoDataPresent" /></div>
      )
    } else {
      return (
        <div className='authError'><AuthError retry={handleRetry} errorMessage="cannotFetch" /></div>
      )
    }
  }

  function handleAssetSummary (): any {
    if (props.assetData.isLoading) {
      return (
        <div className='deviceDetailsProgress'><CircularProgress data-testid='deviceDetailsProgress' size={'5rem'} /></div>)
    } else if (props.assetData.httpStatus === 401) {
      return (
        <div className='authError'><AuthError errorMessage="Unauthorized" /></div>
      )
    } else if (props.assetData.httpStatus === 403) {
      return (
        <div className='authError'><AuthError errorMessage="accessForbidden" /></div>
      )
    } else if (props.assetData.assetData !== null && props.assetData.assetData !== undefined && props.assetData.httpStatus === 200) {
      return (
        <AssetSummary assetId={assetId ?? props.assetData.assetData.id} assetData={props.assetData} OverviewStrings={props.OverviewStrings} assetPropertiesData={props.assetPropertiesData} />)
    } else {
      return (
        <div className='authError'><AuthError retry={props.handleFetchAssetData} errorMessage="cannotFetch" /></div>
      )
    }
  }

  return (
    <div>
     <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
          <Tab sx={{ color: 'gray' }} label={`${props.OverviewStrings.ACTIVE_ISSUES} (${props.alarmsById.alarmData?.alarmDetails.length ?? 0})`} value="1" />
          <Tab sx={{ color: 'gray' }} label={`${OverviewStrings.AlarmHistory} (${totalCount !== undefined ? totalCount : 0})`} value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
        <Grid item xs={12} sm={12} className='active-issues'>
        <Card sx={{ borderRadius: '10px', backgroundColor: '#353535' }}>
          <CardContent sx={{ padding: '0px !important', color: '#F0F0F0 !important' }}>
            {AlarmTable()}
          </CardContent>
        </Card>
      </Grid>
        </TabPanel>
        <TabPanel value="2">
          <AlarmHistory />
        </TabPanel>
      </TabContext>
    </Box>
      <br />
      <Grid item xs={12} sm={12}>
        <Card sx={{ borderRadius: '10px', backgroundColor: '#272727', color: '#F0F0F0 !important', padding: '25px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <h4 style={{ margin: 0 }}>{props.OverviewStrings.ASSET_SUMMARY}</h4>
            {operationPermissions.permissions.can_modify_asset
              ? <Button
                  data-testid=''
                  className='btn-asset'
                  onClick={() => { navigate('/edit-asset-summary') }}
                  disabled={props.assetData.assetData?.asset_state === 'Removed'}
                  primaryColor={props.assetData.assetData?.asset_state === 'Removed' ? '#B0B0B0' : undefined}
                >
                  {OverviewStrings.Edit}
                </Button>
              : null
            }
          </div>
          <CardContent>
            {handleAssetSummary()}
          </CardContent>
        </Card>
      </Grid>
    </div>
  )
}

export default Overview
